module.exports = __webpack_public_path__ + "img/DE01784.0f482be7.png";